export default __webpack_public_path__ + "static/media/header.cc3d45d7.png";